import { Spinner } from '@nextui-org/react'
import useSiteConfiguration from '@scripts/frontend/libs/hooks/useSiteConfiguration'

import { PopupEventItem } from './components/PopupEventItem'

export function PopupEvent() {
  const { error, isLoading, popups } = useSiteConfiguration()

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner size="lg" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex h-full items-center justify-center text-red-500">
        Error: {error.message}
      </div>
    )
  }

  return (
    <div>
      {popups?.map((popup) => (
        <PopupEventItem key={popup.id} {...popup} />
      ))}
    </div>
  )
}

export default PopupEvent
